export enum FieldWrapper {
    FormField = 'custom-form-field',
    HorizontalFormField = 'horizontal-form-field',
    NoLabel = 'no-label',
    NoLabelNoMargin = 'no-label-no-margin',
    NoMarginFormField = 'no-margin-form-field',
    FieldSet = 'field-set',
    Card = 'card-wrapper',
    Table = 'table-wrapper',
    TableRow = 'table-row-wrapper',
    TableColumn = 'table-column-wrapper',
    InputGroup = 'input-group-wrapper',
}